import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

class FuelFilledStore {
  fuelFilled = [];
  // users=[]
  // drivers=[]
  // staff=[]
  // passengers=[]
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      fuelFilled: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getFuelFilledData: action,
      exportExcel: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;
    const params = { companyId: companyId, offset: 0, limit: 15, page: 1 };
    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/FuelDetails/getFuelFilledDetails", {
        params: params,
      });
    this.fuelFilled = response?.data?.data;
    this.loading = false;
  }
  async addData(postData) {
    var fuelData = { postData };
    var response = await postApi
      .getClient()
      .post(
        config.NodeUrl + "/FuelDetails/saveFuelFilledDetailsData",
        fuelData
      );
    return response.data;
  }

  async deleteRecord({ fuel_Id }) {
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/FuelDetails/deleteFuelFilledDetails", {
        params: {
          fuel_Id: fuel_Id,
        },
      });
    return response;
  }
  async getFuelFilledData({ fuel_Id, offset, limit }) {
    const params = { fuel_Id, limit: 1, offset: 0 };
    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/FuelDetails/getFuelFilledDetails", {
        params: params,
      });
    return response.data?.data[0];
  }

  async exportExcel(postData) {
    try {
      var response = await postApi
        .getClient()
        .post(
          config.NodeUrl + "/FuelDetails/exportFuelFilledDetailsExcel",
          postData,
          {
            responseType: "blob",
          }
        );
      // console.log(response, "response");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Fuel Filled Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
}

export default FuelFilledStore;
